export default "__VITE_ASSET__CrF8yzMt__"